module.exports = __webpack_public_path__ + "assets/img/product-index5.59a42746.png";